import { shiftDate, todayJst, useStore } from '../state/store.js';

export function DateNav(): JSX.Element {
  const date = useStore((s) => s.date);
  const setDate = useStore((s) => s.setDate);
  const triggerRefresh = useStore((s) => s.triggerRefresh);

  // 「現在」ボタンは日付スナップに加えて常に再フェッチを行う。
  // PWA 復帰時に古い表示のままになる問題を、
  // 「ずれてると思ったら現在を押す」という自然な操作で解決するため。
  const onClickNow = (): void => {
    setDate(todayJst());
    triggerRefresh();
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => setDate(shiftDate(date, -1))}
        className="px-3 py-1 rounded bg-slate-700 hover:bg-slate-600"
      >
        ← 前日
      </button>
      <button
        type="button"
        onClick={onClickNow}
        className="px-3 py-1 rounded bg-sky-700 hover:bg-sky-600"
        aria-label="現在の日時に更新"
      >
        現在
      </button>
      <button
        type="button"
        onClick={() => setDate(shiftDate(date, 1))}
        className="px-3 py-1 rounded bg-slate-700 hover:bg-slate-600"
      >
        翌日 →
      </button>
      {/* 日付・曜日は AlmanacBadges に集約 */}
    </div>
  );
}
